<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <user-profile />
    </div>
  </div>
</template>

<script>
import UserProfile from '../Components/UserProfile.vue';

export default {
  name: 'Organizations',
  components: {
    'user-profile': UserProfile,
  },

};
</script>

<style scoped>
.content-section {
  padding-top: 80px;
}
</style>
